import * as am5 from '@amcharts/amcharts5';
import * as am5map from "@amcharts/amcharts5/map";
import lithuaniaMunicipalities from "./lithuaniaMunicipalities";
import lithuaniaCounties from "./lithuaniaCounties";

class StatisticsMap{
	static init($context = null){
		var inputSelector = "[data-map-container]";
		let $containers = $context ? $context.find(inputSelector) : $(inputSelector);


		$containers.each(function (index, container) {
			if($(container).data('map_instance')) return;
			$(container).data('map_instance', new StatisticsMap(container))
		});
	}



	constructor(wrap) {
		this.wrap = wrap
		this.$wrap = $(wrap)
		this.xhr = null;
		this.dataUrl = $(wrap).data("url");
		this.dateType = 'Y';

		this.firstDate = '9999-99-99';
		this.lastDate = '0000-00-00';
		this.loadedData = null;

		$('a#charts-tab').on('shown.bs.tab', function (e){
			this.checkVisibility();
		}.bind(this))


		var root = this.root = am5.Root.new(wrap, {});

		//root.container.layout = root.verticalLayout

		var chart = this.chart = root.container.children.push(
			am5map.MapChart.new(root, {
				panX: "none",
				panY: "none",
				wheelY: "none",
				paddingBottom: 50
				//height: new am5.Percent(50)
			})
		);

		this.geoJSON = lithuaniaCounties;
		switch (this.$wrap.data('map-type')) {
			case 'lt_municipalities':
				this.geoJSON = lithuaniaMunicipalities
				break;
			case 'lt_counties':
				this.geoJSON = lithuaniaCounties
				break;
		}

		let polygonSeries = this.polygonSeries = chart.series.push(
			am5map.MapPolygonSeries.new(root, {
				geoJSON: this.geoJSON,
				calculateAggregates: true,
				valueField: "value",
				fill: am5.color('#a3c7c3')
			})
		);

		polygonSeries.mapPolygons.template.setAll({
			tooltipText: "{name}: {value}",
			interactive: true
		});

		polygonSeries.set("heatRules", [{
			target: polygonSeries.mapPolygons.template,
			dataField: "value",
			min: am5.color('#a3c7c3'),
			max: am5.color('#357266'),
			key: "fill"
		}]);

		polygonSeries.mapPolygons.template.states.create("hover", {
			fill: am5.color('#5E0170')
		});

		var container = root.container.children.push(am5.Container.new(root, {
			y: am5.p100,
			centerX: am5.p50,
			centerY: am5.p100,
			x: am5.p50,
			width: am5.percent(90),
			layout: root.horizontalLayout,
			paddingBottom: 20
		}));


		var slider = this.slider = container.children.push(am5.Slider.new(root, {
			//width: am5.percent(80),
			orientation: "horizontal",
			start: 1,
			centerY: am5.p50
		}));

		slider.startGrip.get("icon").set("forceHidden", true);
		slider.startGrip.set("label", am5.Label.new(root, {
			text: "",
			paddingTop: 0,
			paddingRight: 0,
			paddingBottom: 0,
			paddingLeft: 0
		}));

		var rangechangedTimeoutId;
		slider.events.on("rangechanged", function () {
			if(!this.loadedData) return

			let firstDate = Date.parse(this.firstDate)
			let diff = Date.parse(this.lastDate) - firstDate
			let diffDate = new Date(firstDate + diff * slider.get("start", 0))

			var diffDateFormatted = null;
			switch (this.dateType){
				case 'Y':
					diffDateFormatted = diffDate.getFullYear();
					break;
				case 'M':
					throw new Error("M date type is not implemented")
					diffDateFormatted = diffDate.getFullYear() + '-' + diffDate.getMonth();
					break;
				case 'Q':
					throw new Error("Q date type is not implemented")
					diffDateFormatted = diffDate.getFullYear() + '-Q' + diffDate.getMonth();
					break;
			}

			if(diffDateFormatted != this.currentDate){
				this.currentDate = diffDateFormatted
				slider.startGrip.get("label").set("text", this.currentDate);
			}
			clearTimeout(rangechangedTimeoutId);
			rangechangedTimeoutId = setTimeout(function (){
				this.redrawMap()
			}.bind(this), 33);
		}.bind(this));
	}

	checkVisibility(){
		if(this.$wrap.closest('.tab-pane').hasClass('active')){
			this.reloadData()
		}
	}
	reloadData(){
		var reqData = {
		};

		this.xhr = $.ajax({
			type: "POST",
			url: this.$wrap.data("url"),
			data: reqData,
			dataType: 'json',
			success: function (response) {
				this.xhr = null;
				if (response) {
					this.setData(response);
				}
				//that.$preloader.hide();
			}.bind(this)
		})
	}

	setData(data){
		this.loadedData = data;
		let dates = Object.keys(this.loadedData);
		dates.forEach(function (dt){
			if(dt > this.lastDate) this.lastDate = dt;
			if(dt < this.firstDate) this.firstDate = dt;
		}.bind(this))

		this.currentDate = this.lastDate

		this.slider.startGrip.get("label").set("text", this.currentDate);
		this.redrawMap();
	}

	redrawMap(date){
		date = date || this.currentDate
		let dateData = this.loadedData[date]
		dateData.forEach(function (el){
			el.id = this.mapLocation(el.location)
		}.bind(this))

		let excludedData = this.excludeLocations(dateData)



		this.polygonSeries.data.setAll(excludedData);
	}

	mapLocation(location){
		return location
	}

	/**
	 * Removes locations, that does not exist in map
	 * @param data
	 */
	excludeLocations(data){

		let existingLocationIds = this.geoJSON.features.map(function (feature) {
			return feature.id
		})

		let excludedData = [];
		data.forEach(function (datum){
			if(existingLocationIds.indexOf(datum.location) > -1){
				excludedData.push(datum)
			}
		})

		return excludedData
	}
}


StatisticsMap.$ = $;
if (typeof module === "object" && typeof module.exports === "object"){
	StatisticsMap.init()
	//node modules support
	module.exports = StatisticsMap;
}else{
	$(function(){
		StatisticsMap.init()
	});
}